// Regiao de Estudo
// import Fuse from 'fuse.js'
import theapi from '@/api.js'
// import * as turf from '@turf/turf'

import nearestPointToLine from '@turf/nearest-point-on-line';
import length from '@turf/length'
import lineSliceAlong from '@turf/line-slice-along'
import lineSlice from '@turf/line-slice'
// import lineDistance from '@turf/distance'
// import {featureCollection} from '@turf/feature-collection'
import {featureCollection} from '@turf/helpers';

var turf = {
    length,
    lineSliceAlong,
    lineSlice,
    nearestPointToLine,
    lineDistance:length,
    featureCollection
}


var  colorPallete = ['#229331','#F96C0C','#179CF9','#EB00F9','#FFAD00','#5389AB','#ACD72D','#B00047','#A200A9'];

export default function(data) {

    var API_percurso = theapi.percurso;

    var state = {
       teams:[],
       teamsTotal:0,
       categories:[],
       followRunners:[],
       categoriesFilter:false,
       positionsGeoJSON:false,
    }


    return {
        state: state,

        //--MUTATIONS
        mutations: {         

            setTeams:function(state,teams){
                state.teams = teams;
            },

            setTrackState:function(state,{key,value}){
                state[key] = value;
            },

            setPositionsGeoJSON:function(state,geojson){
                state.positionsGeoJSON = positionsGeoJSON;
            }
           

        },


        //--ACTIONS
        actions: {
           
            loadTeams:function(ctx){
                $.getJSON( window.API.tracker+"get_teams", (teams)=>{

                        teams = _.map(teams,team=>{
                            //convert info to object. Sinci it is not a valid json, do manually
                            var infoObj = {}
                            var info = team.info;
                            var info2 = info.replace(/[{}]/g,'');
                            info2 = info2.replace(/['"]/g,'');
                            var properties = info2.split(',');
                            _.each(properties, prop=>{
                                var keyValue = prop.split(':');
                                infoObj[keyValue[0]] = keyValue[1]
                            })
                            // info.replace
                            // var info = JSON.parse(team.info);
                            delete team.info;
                            team = {...team,...infoObj}
                            return team;
                        })

                        ctx.commit('setTrackState',{key:'teamsTotal',value:teams.length})
                        
                        teams = _.keyBy(teams,'cd_team')
                        ctx.commit('setTeams',teams)
                })
            },


            loadRunnersPositions:function(ctx){
                   $.getJSON( window.API.tracker+"get_runners_position", (data)=>{
                             ctx.commit('setPositionsGeoJSON',data)
                   })
            }




        },


        //--GETTERS
        getters: {

            runnersPossitions: state=>state.positionsGeoJSON
            
            // trechoRunnerName: (state,getters) => (trechoID) =>{

            // },

          
        },

    }
}

